///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Toolbar } from 'ngx-editor';
import { defaultToolbarRules, NoteItem } from './release-notes-note-item.model';

export class GtthReleaseNotesLimitation implements NoteItem {
    public readonly DIALOG_TITLE_TRANSLATION_PATH = 'releaseNotes.limitation.createOrEditLabel';
    public fieldList: { title: string; content: string; editorToolbar: Toolbar }[] = [];

    constructor(
        public topic?: string,
        public limitation?: string,
        public notes?: string
    ) {
        this.fieldList.push({ title: 'topic', content: this.topic, editorToolbar: [] });
        this.fieldList.push({ title: 'limitation', content: this.limitation, editorToolbar: defaultToolbarRules });
        this.fieldList.push({ title: 'notes', content: this.notes, editorToolbar: defaultToolbarRules });
    }

    getPlainObject(): any {
        const releaseNoteItem = {};
        this.fieldList.forEach((field) => (releaseNoteItem[field.title] = field.content));
        return releaseNoteItem;
    }
}
